// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
import { getDefaultSlots } from '@progress/kendo-vue-common';
/**
 * Represents the GridToolbar component.
 *
 */

/**
 * Represents the default `GridToolbar` component.
 */

var GridToolbarVue2 = {
  name: 'GridToolbar',
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultSlot = getDefaultSlots(this);
    return h("div", {
      "class": "k-toolbar k-grid-toolbar"
    }, [defaultSlot]);
  }
};
var GridToolbar = GridToolbarVue2;
export { GridToolbar, GridToolbarVue2 };